import { render, staticRenderFns } from "./selectzones.vue?vue&type=template&id=38970777&"
import script from "./selectzones.vue?vue&type=script&lang=ts&"
export * from "./selectzones.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports